<template lang="pug">
  div
    ods-chart(type="singleLine" :data='chart' orientation="horizontal" symbol="")
</template>

<script>
export default {
  name: 'Chart',
  props: {
    dataChart: {
      type: Object
    }
  },
  data () {
    return {
      chart: []
    }
  },
  computed: { },
  watch: {
    dataChart (newVal, oldVal) {
      const component = this
      component.chart = newVal
    }
  },
  created () {
    this.chart = this.dataChart
  }
}
</script>

<style lang="scss" scoped>

  .legend {
    margin: rem(16) 0;
    span {
      color: $--color-neutral-1;
      font-size: rem(9);
      font-weight: 500;
      line-height: rem(16);
      margin-right: rem(40);
      text-transform: uppercase;
      &::before {
        content: '';
        background: $--color-primary;
        border-radius: 100%;
        display: inline-block;
        height: rem(10);
        margin-right: rem(10);
        vertical-align: middle;
        width: rem(10);
      }
      &.simulated::before {
        background: $--color-primary;
      }
      &.historic::before {
        background: $--color-secondary;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Chart.vue